var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.card)?_c('FollowUp',{ref:"followUp",attrs:{"card":_vm.card,"isModal":true},on:{"Reload":function($event){return _vm.onClose(true)},"followupEmited":_vm.onSave}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b114402","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/crm/board/modal/event/followupevent.vue
// module id = null
// module chunks = 